/*----------------------------------------后台Api地址----------------------------------------*/
export const RELEASE = true;//true 正式环境 false 测试环境
export const APP_SERVE_URL = RELEASE ? 'http://api.jilisi.com/' : 'http://api.btobvip.com/';
export const SHARE_URL = RELEASE ? 'http://m.jilisi.com/':'http://m.btobvip.com/';